import { Component, OnInit, Input, Inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NGXLogger } from "ngx-logger";
import { ISelectFeatureConnected, ISelectedFeatures, authOpt, authType } from "../../definitions";
import { UserSettingsService } from "../../services/user-settings-service";
import { WindowMessageService } from "../../services/window-message-service";
import { getExMessage } from "../../map/map-utils";



import Feature from 'ol/Feature';

    export interface ISpatiuVerde {
        proprietar: string;
        proprietate: string;
        modAdministrare: string;
        categorieDeFolosinta: string;
        reglementareUrbanistica: string;
        suprafataMasurataTerenExclusiv: number;
        suprafataMasurataTerenIndiviziune: number;
        totalTerenSpatiuVerde: number;
        observatii: string;
    }
   
    //
    export interface IConstructie {
        proprietar: string;
        proprietate: string;
        modAdministrare: string;
        nrCorpConstructie: string;
        codGrupaDestinatie: string;
        suprafataConstruitaLaSol: number;
        observatii: string;
    }

    export interface IVegetatie {
        nr: string;
        prescurtare: string;
        categorie: string;
        denumireStiintifica: string;
        denumirePopulara: string;
        numarExemplare: number;
        diametru: number;
        inaltime: number;
        varsta: number;
        observatii: string;
        ocrotit?: boolean;
        izolat?: boolean;
    }
    export interface IArbore {
        nr: string;
        specia: string;
        inaltimeArbore: string;
        inaltimeTrunchi: string;
        numarIdentificare: string;
        ocrotit: string;
        suport: string;
        varsta: string;
        sanatate: string;
        intretinere: string;
        diametru?: string;
        amplasare?: string;
        categorie?: string;
        lucrari?: string;
    }
    //
    export interface IVegetatieGroup {
        categorie: string;
        total: number;
        vegetatie: Array<IVegetatie>; 
    }
    //
    export interface ISpatiuVerdeRaportItem {
        //
        connectedFeatures: Array<ISelectFeatureConnected>;
        spatiuVerdeFeatures: Array<Feature>;
        constructiiFeatures: Array<ISelectedFeatures>;
        vegetatieFeatures: Array<ISelectedFeatures>;
        arboriFeatures: Array<ISelectedFeatures>;
        //
        headInfo: IHeadInfo;
        mapImgUrl: string;
        adresa: string;
        //
        spatiiVerzi: Array<ISpatiuVerde>;
        constructii: Array<IConstructie>;
        vegetatie: Array<IVegetatie>;
        arbore: Array<IArbore>;
        vegetatieGroups: Array<IVegetatieGroup>;
        //vegetatieIzolata: Array<IVegetatie>;
        //vegetatieOcrotita: Array<IVegetatie>;
        //
        totalTerenSpatiiVerzi: number;
        totalSuprafataDinTerenSpatiuVerde: number;
        //
        echipareEdilitara: string;
        vegetatieExistenta: string;
        documenteEmise: string;
        printDate: string;
        numeMunicipiu: string;
        numeAprobat: string;
        dataAprobat: string;
        numeSursaUrl: string;
    }
    //
    export interface IHeadInfo {
        judet: string,
        localitatea: string,
        codSiruta: string,

        sectiunePlan: string,
        nrCadastral: string,
        nrCarteFunciara: string,

        codZonaValorica: string,
        codZonaProtejata: string,
        codPostal: string,

        adresa: string
    }
    //
    @Component({
        selector: 'fisa-spatiului-verde',
        providers: [],
        templateUrl: './fisa-spatiului-verde.component.html',
        styleUrls: ['./fisa-spatiului-verde.component.css']
    })
    export class FisaSpatiuluiVerdeComponent implements OnInit{
        //
        selectedFeaturesConnectedOnLayers: Array<ISelectFeatureConnected>;
        //
        public mapImgUrl: string;
        //public svRaport: ISpatiuVerdeRaportItem = this.newReportItem();
        public svRaports: Array<ISpatiuVerdeRaportItem> = [];
        //
        //
        public denumiriColoaneHeader = {
            judetul: "Judetul",
            localitatea: "Localitatea",
            codsiruta: "Cod SIRUTA",
            sectiunePlan: "Sectiune plan",
            nrCadastral: "Nr. cadastral imobil",
            nrCarteFunciara: "Nr. carte funciara",
            codZonaValorica: "Cod zona valorica",
            codZonaProtejata: "Cod zona protejata",
            codPostal: "Cod postal"
        }
        //
        public numeInInfoHeaderSpatiuVerde = {
            judetul: "judetul",
            localitatea: "localitatea",
            codsiruta: "cod_SIRUTA",
            sectiunePlan: "sectiune_plan",
            nrCadastral: "nrcad_topo",
            nrCarteFunciara: "nr_carte_funciara",
            codZonaValorica: "cod_zona_valorica",
            codZonaProtejata: "cod_zona_protejata",
            codPostal: "cod_postal",
            adresa: "adresa"
        }
        //
        public denumiriColoaneSpatiuVerde = {
            proprietar: "Proprietar / Detinator spatiu verde",
            proprietate: "Tip proprietate",
            modAdministrare: "Mod administrare",
            categorieDeFolosinta: "Categorie de folosinta",
            reglementareUrbanistica: "Reglementare urbanistica",
            suprafataMasurataTerenExclusiv: "Suprafata masurata teren exclusiv",
            suprafataMasurataTerenIndiviziune: "Suprafata masurata teren indiviziune",
            totalTerenSpatiuVerde: "Total teren spatiu verde",
            observatii: "Observatii",
        }
        public numeInInfoFeatureSpatiuVerde = {
            proprietar: "proprietar",
            proprietate: "denumire",
            modAdministrare: "mod_de_adm",
            categorieDeFolosinta: "categorie",
            reglementareUrbanistica: "reglementare_urbanistica",
            suprafataMasurataTerenExclusiv: "suprafata",
            suprafataMasurataTerenIndiviziune: "teren_indiviziune",
            totalTerenSpatiuVerde: "suprafata",
            observatii: "observatii",
        }
        //
        public denumiriColoaneConstructie = {
            proprietar: "Proprietar",
            proprietate: "Tip proprietate",
            modAdministrare: "Mod administrare",
            nrCorpConstructie: "Nr. corp constructie",
            codGrupaDestinatie: "Cod grupa destinatie",
            suprafataConstruitaLaSol: "Suprafata construita la sol",
            observatii: "Observatii",
        }
        public numeInInfoFeatureConstructie = {
            proprietar: "proprietar",
            proprietate: "denumire",
            modAdministrare: "mod_de_administrare",
            nrCorpConstructie: "nr_corp_constructie",
            codGrupaDestinatie: "cod_grupa_destinatie",
            suprafataConstruitaLaSol: "suprafata_construita_la_sol",
            observatii: "observatii",
        }

        public denumiriColoaneVegetatie = {
            nr: "Nr. crt.",
            prescurtare: "Prescurtare",
            categorie: "Categorie",
            denumireStiintifica: "Denumire stiintifica",
            denumirePopulara: "Denumire populara",
            numarExemplare: "Numar exemplare",
            diametru: "DIAM. cm",
            inaltime: "INAL. m",
            varsta: "VARSTA ani",
            observatii: "Obs.",
        }
        public numeInInfoFeatureVegetatie = {
            nr: "nrunic",
            prescurtare: "prescurtare",
            categorie: "categorie",
            denumireStiintifica: "denumire_stintifiica",
            denumirePopulara:"specie",
            numarExemplare: "numar",
            diametru: "coronament",
            inaltime: "inaltime",
            varsta: "varsta",
            observatii: "observatii",
            ocrotit: "ocrotit",
            izolat: "izolat"
        }
        public  denumireColoaneArbore = {
            nr: "Nr.",
            specia: "Specia",
            inaltimeArbore: "Inaltime arbore",
            inaltimeTrunchi: "Inaltime trunchi",
            numarIdentificare: "NUI",
            ocrotit: "Ocrotit",
            suport: "Suport",
            varsta: "Varsta",
            sanatate: "Sanatate",
            intretinere: "Intretinere",
            diametru: "Diametru",
            amplasare: "Amplasare",
            categorie: "Categorie",
            lucrari: "Lucrari",
        }

        public  numeInInfoFeatureArbore = {
            specia: "specia",
            inaltimeArbore: "inaltime_arbore",
            inaltimeTrunchi: "inaltime_trunchi",
            numarIdentificare: "nrunic",
            ocrotit: "ocrotit",
            suport: "suport",
            varsta: "varsta",
            sanatate: "sanatate",
            intretinere: "intretinere",
            diametru: "diametru",
            amplasare: "amplasare",
            categorie: "categorie",
            lucrari: "lucrari",
        }
        //
        @Input() data: any;
        //
        constructor(
            @Inject(NgbActiveModal) private activeModal: NgbActiveModal,
            @Inject(NGXLogger) private $log: NGXLogger,
            @Inject(UserSettingsService) private userSettingsService: UserSettingsService,
            @Inject(WindowMessageService) private windowMessageService: WindowMessageService,
            @Inject(DomSanitizer) private sanitizer: DomSanitizer,
        ) {
            //test only
        }
        public ngOnInit(): void {
            if (this.data.mapImgUrl && this.data["selectedFeaturesConnectedOnLayers"]) {
                this.selectedFeaturesConnectedOnLayers = this.data["selectedFeaturesConnectedOnLayers"];
                this.mapImgUrl = this.sanitizer.bypassSecurityTrustUrl(this.data.mapImgUrl) as any;
                //this.processTablesDataCombined();
                this.processTablesDataSeparated();
            }
            else {
                this.$log.warn("straturile cu date nu exista");
                this.activeModal.close(false);
            }
        }

        private newReportItem(): ISpatiuVerdeRaportItem {
            let printdate = new Date().getDate().toString() + "." + (new Date().getMonth() + 1).toString() + "." + new Date().getFullYear().toString();
            
            return {
                connectedFeatures: [],
                spatiuVerdeFeatures: [],
                constructiiFeatures: [],
                vegetatieFeatures: [],
                arboriFeatures: [],
                
               // vegetatieIzolata: [],
               // vegetatieOcrotita: [],
                //
                headInfo: {
                    judet: "",
                    localitatea: "",
                    codSiruta: "",
                    //
                    sectiunePlan: "",
                    nrCadastral: "",
                    nrCarteFunciara: "",
                    //
                    codZonaValorica: "",
                    codZonaProtejata: "",
                    codPostal: "",
                    adresa: ""
                },
                mapImgUrl: "",
                adresa: "",
                spatiiVerzi: [],
                constructii: [],
                vegetatie: [],
                arbore: [],
                vegetatieGroups: [],
                totalTerenSpatiiVerzi: 0,
                totalSuprafataDinTerenSpatiuVerde: 0,
                //
                echipareEdilitara: "",
                vegetatieExistenta: "",
                documenteEmise: "nu e cazul.",
                printDate: printdate,
                dataAprobat: "-",
                numeAprobat: "-",
                numeMunicipiu: "-",
                numeSursaUrl: "https://geoportal.e-bistrita.ro"
            }
        }
        //
        // private processTablesDataCombined() {
        //     this.svRaports = [];
        //     let tmpReport = this.newReportItem();
        //     let message = "";
        //     //
        //     this.selectedFeaturesConnectedOnLayers.forEach((selItem) => {
        //         try {
        //             tmpReport.spatiuVerdeFeatures.push(selItem.feature);
        //             selItem.connectedConstructii.forEach((conItem) => {
        //                 tmpReport.constructiiFeatures.push(conItem);
        //             });
        //             selItem.connectedVegetatie.forEach((conItem) => {
        //                 tmpReport.vegetatieFeatures.push(conItem);
        //             });
        //         } catch (e) {
        //             message += " -- " + e.message || '';
        //         }
        //     });
        //     //
        //     this.processReportItemTables(tmpReport);
        //     this.svRaports.push(tmpReport);
        //     //
        //     if (message.length > 0) {
        //         this.$log.error("erroare parsare: ", getExMessage(message));
        //     }

        // }

        private processTablesDataSeparated() {
            this.svRaports = [];
            let message = "";
            this.selectedFeaturesConnectedOnLayers.forEach((selItem) => {
                try {
                    let tmpRitem = this.newReportItem();
                    let numeMun =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_spatiuverde_info_municipiu, selItem.layer["appLayer"]["name"], authType.layer)
                    if (numeMun && numeMun.descriere){
                        tmpRitem.numeMunicipiu = numeMun.descriere;
                    }
                    let numeApr =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_spatiuverde_info_aprobat_nume, selItem.layer["appLayer"]["name"], authType.layer)
                    if (numeApr && numeApr.descriere){
                        tmpRitem.numeAprobat = numeApr.descriere;
                    }
                    let dataApr =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_spatiuverde_info_aprobat_data, selItem.layer["appLayer"]["name"], authType.layer)
                    if (dataApr && dataApr.descriere){
                        tmpRitem.dataAprobat = dataApr.descriere;
                    }
                    let sursaUrl =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_spatiuverde_info_nume_sursa_url, selItem.layer["appLayer"]["name"], authType.layer)
                    if (sursaUrl && sursaUrl.descriere){
                        tmpRitem.numeSursaUrl = sursaUrl.descriere;
                    }
                    
                    tmpRitem.connectedFeatures.push(selItem);
                    tmpRitem.spatiuVerdeFeatures.push(selItem.feature);
                    selItem.connectedConstructii.forEach((conItem) => {
                        tmpRitem.constructiiFeatures.push(conItem);
                    });
                    selItem.connectedVegetatie.forEach((conItem) => {
                        tmpRitem.vegetatieFeatures.push(conItem);
                    });
                    selItem.connectedArbori.forEach((conItem)=>{
                        tmpRitem.arboriFeatures.push(conItem);
                    })
                    //
                    this.processReportItemTables(tmpRitem);
                    //
                    this.svRaports.push(tmpRitem);
                    //testonly
                    //this.svRaports.push(tmpRitem);
                } catch (e) {
                    message += " -- " + e.message || '';
                }
            });
            //
            if (message.length > 0) {
                this.$log.error("erroare parsare: ", getExMessage(message));
            }
        }

        private processReportItemTables(raportItem: ISpatiuVerdeRaportItem) {
            let message = "";
            //
            raportItem.spatiuVerdeFeatures.forEach((svitem) => {
                try {
                    let tmpItem = this.processFeatureSpatiuVerde(svitem);
                    raportItem.spatiiVerzi.push(tmpItem);
                    raportItem.totalTerenSpatiiVerzi += tmpItem.totalTerenSpatiuVerde;
                    //
                    if (raportItem.spatiiVerzi.length === 1) {
                        raportItem.headInfo = this.processHeaderSpatiuVerde(svitem);
                        raportItem.adresa = raportItem.headInfo.adresa;
                    } else {
                        //cumuleaza info
                        this.cumulateHeaderSpatiuVerde(svitem, raportItem.headInfo);
                    }
                     //
                } catch (e) {
                    message += " -- " + e.message || '';
                }
            });
            //
            raportItem.constructiiFeatures.forEach((clfitem) => {
                clfitem.features.forEach((citem) => {
                    try {
                        let tmpItem = this.processFeatureConstructii(citem);
                        raportItem.constructii.push(tmpItem);
                        raportItem.totalSuprafataDinTerenSpatiuVerde += tmpItem.suprafataConstruitaLaSol;
                    } catch (e) {
                        message += " -- " + e.message || '';
                    }
                })
            });
            //vegetatie
            raportItem.vegetatieFeatures.forEach((clfitem) => {
                clfitem.features.forEach((citem, index) => {
                    try {
                        let tmpItem = this.processFeatureVegetatie(citem);
                        tmpItem.nr = (index + 1).toString();
                        raportItem.vegetatie.push(tmpItem);
                    } catch (e) {
                        message += " -- " + e.message || '';
                    }
                })
            });
            //arbori
            raportItem.arboriFeatures.forEach((clfitem) => {
                clfitem.features.forEach((citem, index) => {
                    try {
                        let tmpItem = this.processFeatureArbore(citem);
                        tmpItem.nr = (index + 1).toString();
                        raportItem.arbore.push(tmpItem);
                    } catch (e) {
                        message += " -- " + e.message || '';
                    }
                })
            });
            //create groups
            this.processVegetatieGroups(raportItem);
            //
            if (message.length > 0) {
                this.$log.error("erroare parsare: ", getExMessage(message));
            }
        }

        
        private processHeaderSpatiuVerde(feature: Feature): IHeadInfo {
            var tmpsv: IHeadInfo = null;
            try {
                tmpsv = {
                    judet: feature.get(this.numeInInfoHeaderSpatiuVerde.judetul) || '',
                    localitatea: feature.get(this.numeInInfoHeaderSpatiuVerde.localitatea) || '',
                    codSiruta: feature.get(this.numeInInfoHeaderSpatiuVerde.codsiruta) || '',
                    sectiunePlan: feature.get(this.numeInInfoHeaderSpatiuVerde.sectiunePlan) || '',
                    nrCadastral: feature.get(this.numeInInfoHeaderSpatiuVerde.nrCadastral) || '',
                    nrCarteFunciara: feature.get(this.numeInInfoHeaderSpatiuVerde.nrCarteFunciara) || "",
                    codPostal: feature.get(this.numeInInfoHeaderSpatiuVerde.codPostal) || "",
                    codZonaValorica: feature.get(this.numeInInfoHeaderSpatiuVerde.codZonaValorica) || "",
                    codZonaProtejata: feature.get(this.numeInInfoHeaderSpatiuVerde.codZonaProtejata) || '',
                    adresa: feature.get(this.numeInInfoHeaderSpatiuVerde.adresa) || ''
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpsv;
        }
        //
        private cumulateHeaderSpatiuVerde(feature: Feature, headerInfo: IHeadInfo) {
            let tmp = this.processHeaderSpatiuVerde(feature);
            headerInfo.judet = headerInfo.judet + tmp.judet;
            headerInfo.localitatea = headerInfo.localitatea + tmp.localitatea;
            headerInfo.codSiruta = headerInfo.codSiruta + tmp.codSiruta;
            headerInfo.sectiunePlan = headerInfo.sectiunePlan + tmp.sectiunePlan;
            headerInfo.nrCadastral = headerInfo.nrCadastral + tmp.nrCadastral;
            headerInfo.nrCarteFunciara = headerInfo.nrCarteFunciara + tmp.nrCarteFunciara;
            headerInfo.codPostal = headerInfo.codPostal + tmp.codPostal;
            headerInfo.codZonaValorica = headerInfo.codZonaValorica + tmp.codZonaValorica;
            headerInfo.codZonaProtejata = headerInfo.codZonaProtejata + tmp.codZonaProtejata;
        }

        private processFeatureSpatiuVerde(feature: Feature): ISpatiuVerde {
            var tmpsv: ISpatiuVerde = null;
            try {
                tmpsv = {
                    proprietar: feature.get(this.numeInInfoFeatureSpatiuVerde.proprietar) || '',
                    proprietate: feature.get(this.numeInInfoFeatureSpatiuVerde.proprietate) || '',
                    modAdministrare: feature.get(this.numeInInfoFeatureSpatiuVerde.modAdministrare) || '',
                    categorieDeFolosinta: feature.get(this.numeInInfoFeatureSpatiuVerde.categorieDeFolosinta) || '',
                    reglementareUrbanistica: feature.get(this.numeInInfoFeatureSpatiuVerde.reglementareUrbanistica) || '',
                    suprafataMasurataTerenExclusiv:  Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenExclusiv)) || 0,
                    suprafataMasurataTerenIndiviziune: Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenIndiviziune)) || 0,
                    totalTerenSpatiuVerde: (Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenExclusiv)) || 0) +
                                            (Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenIndiviziune)) || 0),
                    //totalTerenSpatiuVerde: Number(feature.get(this.numeInInfoFeatureSpatiuVerde.totalTerenSpatiuVerde)) || 0,
                    observatii: feature.get(this.numeInInfoFeatureSpatiuVerde.observatii) || '',
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpsv;
        }

        private processFeatureConstructii(feature: Feature) {
            var tmpCon: IConstructie = null;
            try {
                tmpCon = {
                    proprietar: feature.get(this.numeInInfoFeatureConstructie.proprietar) || '',
                    proprietate: feature.get(this.numeInInfoFeatureConstructie.proprietate) || '',
                    modAdministrare: feature.get(this.numeInInfoFeatureConstructie.modAdministrare) || '',
                    nrCorpConstructie: feature.get(this.numeInInfoFeatureConstructie.nrCorpConstructie) || '',
                    codGrupaDestinatie: feature.get(this.numeInInfoFeatureConstructie.codGrupaDestinatie) || 0,
                    suprafataConstruitaLaSol: Number(feature.get(this.numeInInfoFeatureConstructie.suprafataConstruitaLaSol)) || 0,
                    observatii: feature.get(this.numeInInfoFeatureConstructie.observatii) || '',
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpCon;
        }
        private processFeatureArbore(feature: Feature) {
            var tmpCon: IArbore = null;
            try {
                tmpCon = {

                    nr: feature.get(this.numeInInfoFeatureVegetatie.nr) || 0,
                    specia: feature.get(this.numeInInfoFeatureArbore.specia) || "",
                    inaltimeArbore: feature.get(this.numeInInfoFeatureArbore.inaltimeArbore) || "",
                    inaltimeTrunchi: feature.get(this.numeInInfoFeatureArbore.inaltimeTrunchi) || "",
                    numarIdentificare: feature.get(this.numeInInfoFeatureArbore.numarIdentificare) || "",
                    ocrotit: feature.get(this.numeInInfoFeatureArbore.ocrotit) || "",
                    suport: feature.get(this.numeInInfoFeatureArbore.suport) || "",
                    varsta: feature.get(this.numeInInfoFeatureArbore.varsta) || "",
                    sanatate: feature.get(this.numeInInfoFeatureArbore.sanatate) || "",
                    intretinere: feature.get(this.numeInInfoFeatureArbore.intretinere) || "",
                    diametru: feature.get(this.numeInInfoFeatureArbore.diametru) || "",
                    amplasare: feature.get(this.numeInInfoFeatureArbore.amplasare) || "",
                    categorie: feature.get(this.numeInInfoFeatureArbore.categorie) || "",
                    lucrari: feature.get(this.numeInInfoFeatureArbore.lucrari) || ""
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpCon;
        }

        private processFeatureVegetatie(feature: Feature) {
            var tmpCon: IVegetatie = null;
            try {
                tmpCon = {

                    nr: feature.get(this.numeInInfoFeatureVegetatie.nr) || 0,
                    prescurtare: feature.get(this.numeInInfoFeatureVegetatie.prescurtare) || "",
                    categorie: feature.get(this.numeInInfoFeatureVegetatie.categorie) || "",
                    denumireStiintifica: feature.get(this.numeInInfoFeatureVegetatie.denumireStiintifica) || "",
                    denumirePopulara: feature.get(this.numeInInfoFeatureVegetatie.denumirePopulara) || "",
                    numarExemplare: feature.get(this.numeInInfoFeatureVegetatie.numarExemplare) || 1,
                    diametru: feature.get(this.numeInInfoFeatureVegetatie.diametru) || '-',
                    inaltime: feature.get(this.numeInInfoFeatureVegetatie.inaltime) || '-',
                    varsta: feature.get(this.numeInInfoFeatureVegetatie.varsta) || '-',
                    observatii: feature.get(this.numeInInfoFeatureVegetatie.nr) || "",
                    ocrotit: feature.get(this.numeInInfoFeatureVegetatie.ocrotit),
                    izolat: feature.get(this.numeInInfoFeatureVegetatie.izolat)
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpCon;
        }

        //todo arbori si vegetatie
        private processVegetatieGroups(raportItem : ISpatiuVerdeRaportItem) {
            raportItem.vegetatieGroups = [];
            //arbori
            let tmpgroup = { categorie: "arbori",total: 0, vegetatie: [] };
            let tmparbori = raportItem.arbore || [];
            
            // Extract unique species from arbori
            let uniqueSpecies = this.extractUniqueSpecies(tmparbori);
            //
            uniqueSpecies.forEach((item, index) => {
                let tmpVege = {id:(index + 1).toString(), vegetatie: item, total: 0, };
                tmpVege.total = tmparbori.filter((itema)=> itema.specia === item).length || 0;
                tmpgroup.vegetatie.push(tmpVege);
                tmpgroup.total += tmpVege.total;
            })
            raportItem.vegetatieGroups.push(tmpgroup);
            //vegetatie
            let groups: Array<string> = raportItem.vegetatie.map(x => x.categorie);
            //
            if (groups.length > 0){
                groups = groups.filter((value, index, self) => {
                    return self.indexOf(value) === index;
                });
                //
                groups.forEach((gritem) => {
                    let tmpgroup = { categorie: gritem,total: 0, vegetatie: [] };
                    tmpgroup.vegetatie = raportItem.vegetatie.filter((item) => item.categorie === gritem) || [];
                    tmpgroup.vegetatie.forEach((item: IVegetatie, index) => {
                        //
                        item.nr = (index + 1).toString();
                        let countVegetatie = Number(item.numarExemplare);
                        if (!isNaN(countVegetatie)) {
                            tmpgroup.total += countVegetatie;
                        }
                    })
                    raportItem.vegetatieGroups.push(tmpgroup);
                });
            }

        }

        /**
         * Extract unique species from arbori array
         * @param arbori Array of IArbore objects
         * @returns Array of unique species names
         */
        private extractUniqueSpecies(arbori: IArbore[]): string[] {
            if (!arbori || arbori.length === 0) {
                return [];
            }
            
            // Extract all species names
            let species = arbori.map(arbore => arbore.specia).filter(specia => specia && specia.trim() !== '');
            
            // Remove duplicates
            let uniqueSpecies = species.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            
            return uniqueSpecies;
        }

        public cancel(): void {
            this.activeModal.close(false);
        }

    }
